import { createContext, useContext } from "react";
import { ImagerCalibration, PixelSizeCalibration } from "../../../../Model/ImagerCalibration";
import { ELightPath } from "../../../../Model/CaptureProfile";

export enum ECameraCalibrationType {
  CameraCalibrationSelection,
  CameraOffset,
  ObjectiveOffset,
  FilterCubeOffset,
  FlatFieldCorrection,
  PixelSize,
  WhiteBalance,
  PolarizeOffset
}

export const CameraCalibrationContext = createContext({
  lightpath: ELightPath.Disabled,
  setLightpath: (lightPath: ELightPath) => {},
  calibration: {
    cameraCalibrationType: ECameraCalibrationType.CameraCalibrationSelection,
    setCameraCalibrationType: (camCalibrationType: ECameraCalibrationType) => {},
    pixelSizeCalibration: undefined as PixelSizeCalibration | undefined,
    setPixelSizeCalibration: (pixelSizeCal: PixelSizeCalibration | undefined) => {},
  },
  pixelSize: {
    gridSize: 100,
    setGridSize: (gridSize: number) => {},
    numberOfSquares: 1,
    setNumberOfSquares: (numOfSquare: number) => {},
    lineLength: -1,
    setLineLength: (lineLenght: number) => {},
    pixelSizeValue: 0,
    setPixelSizeValue: (pixelSize: number) => {},
  }
});

export const useCameraCalibrationContext = () => {
  const context = useContext(CameraCalibrationContext);
  if (context == null) {
    throw new Error(
      `Camera Calibration compound components cannot be rendered outside the Imager Settings Component`
    );
  }

  return context;
};